export default "__VITE_ASSET__kKfTXWbT__"